import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { Row, Col, Button, FormGroup, Label, Input, UncontrolledTooltip, Modal, ModalBody, ModalHeader, ListGroup, ListGroupItem } from 'reactstrap';
import { useAuth } from '../../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import PSO from '../../../../services/PSO';
import Strings from '../../../../translations/Translations';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import Slider from 'rc-slider';
import cx from 'classnames';
import Autocomplete from 'react-google-autocomplete';

const COVER_IMG_LOCATION = process.env.REACT_APP_COVER_IMG_LOCATION;
const PUBLIC_VIDEOS_URL = process.env.REACT_APP_PUBLIC_VIDEOS;
const schema = Yup.object().shape({
  rti: Yup.string().required('Required')
});
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export default function EditVideo(props) {
  const { currentIt } = props;
  const { authenticated, toggleLoading, currentCampaign } = useAuth();
  const { register, errors, handleSubmit, setValue } = useForm({
    validationSchema: schema,
  });

  const [modalRemoveVideo, setModalRemoveVideo] = useState(false);
  const toggleModalRemoveVideo = useCallback(() => {
    setModalRemoveVideo(!modalRemoveVideo);
  }, [setModalRemoveVideo, modalRemoveVideo]);

  const [remixPars, setRemixPars] = useState();
  const [remixHashtags, setRemixHashtags] = useState();

  const [showLocation, setShowLocation] = useState(false);
  const [customLatiLong, setCustomLatiLong] = useState(false);

  const modifyRemix = useCallback(async (data) => {
    toggleLoading(true);

    const hashtags = (remixHashtags) ? remixHashtags : ' ||)  #style';
    const rde = data.rde + hashtags;

    try {
      const args = {
        rti: encodeURIComponent(data.rti),
        rde: encodeURIComponent(rde),
        rmcsa: remixPars.rmcsa,
        rautoapp: remixPars.rautoapp,
        rssm: remixPars.rssm,
        rsmir: remixPars.rsmir,
        blksnow: remixPars.blksnow,
        rfsownernm: remixPars.rfsownernm,
        rfsnm: remixPars.rfsnm,
      };

      if (customLatiLong) {
        if (customLatiLong.lati && customLatiLong.lati !== '' && customLatiLong.lati !== ' ' && customLatiLong.lati !== null) {
          args.lati = encodeURIComponent(customLatiLong.lati);
        }
        if (customLatiLong.long && customLatiLong.long !== '' && customLatiLong.long !== ' ' && customLatiLong.long !== null) {
          args.long = encodeURIComponent(customLatiLong.long);
        }
      }

      const response = await PSO.modifyRemix({
        un: authenticated.un,
        al: authenticated.al,
        rid: remixPars.rid,
        args
      });

      if (response.result === 'success') {
        toast.success('Success');
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [toggleLoading, authenticated, remixPars, remixHashtags, customLatiLong]);

  const getPars = useCallback(async () => {
    toggleLoading(true);

    try {
      const response = await PSO.getRemixPars({
        un: authenticated.un,
        al: authenticated.al,
        rid: currentIt.rid
      });

      if (response.result === 'success') {
        if (response.its && response.its[0]) {
          setRemixPars(response.its[0]);
          if (response.its[0].rde && response.its[0].rde.split('||)')[1]) {
            setRemixHashtags(response.its[0].rde.split('||)')[1]);
          }

          const rti = response.its[0].rti;
          const rde = response.its[0].rde.split('||)')[0];
          setValue('rti', rti);
          setValue('rde', rde);
        }
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [authenticated, currentIt, toggleLoading, setRemixHashtags, setValue]);

  useEffect(() => {
    getPars();
  }, [getPars]);

  const confirmRemoveVideoFromCampaign = useCallback(async () => {
    if (currentIt && currentIt.rid) {
      toggleLoading(true);
      try {
        const response = await PSO.removeRemixFromCollection({
          un: authenticated.un,
          al: authenticated.al,
          colid: currentCampaign.colid,
          rid: currentIt.rid
        });

        if (response.result === 'success') {
          toast.success(Strings('video_removed_from_campaign'));
          setTimeout(function () {
            document.location.reload();
          }, 1500);
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_request');
          toast.error(message);
        }

        toggleLoading(false);
      } catch (err) {
        toast.error(Strings('general_error'));
        toggleLoading(false);
      }
    }
  }, [currentIt, toggleLoading, currentCampaign, authenticated]);

  const toggleCustomLatiLong = useCallback((lati, long) => {
    if (lati || long) {
      const info = { lati, long };
      setCustomLatiLong(info);
    } else {
      setCustomLatiLong(false)
    }
  }, [setCustomLatiLong]);


  return (
    <Fragment>
      <Row>
        <FormGroup tag={Col} md={12}>
          <Label for="campaign_name">
            {Strings('title')}
            <span className='ml-1'><i id='rti-info' className='pe-7s-info'></i></span>
          </Label>
          <UncontrolledTooltip
            placement='right'
            target='rti-info'
          >
            {Strings('title_tooltip')}
          </UncontrolledTooltip>

          <Input
            type="text"
            name="rti"
            id="rti"
            innerRef={register}
            defaultValue={remixPars && remixPars.rti}
          />
          {errors.rti && (
            <p className="error-validation text-left">
              {errors.rti.message}
            </p>
          )}
        </FormGroup>
        <FormGroup tag={Col} md={12}>
          <Label for="campaign_name">
            {Strings('description')}
            <span className='ml-1'><i id='rde-info' className='pe-7s-info'></i></span>
          </Label>
          <UncontrolledTooltip
            placement='right'
            target='rde-info'
          >
            {Strings('description_tooltip')}
          </UncontrolledTooltip>

          <Input
            type="textarea"
            name="rde"
            id="rde"
            innerRef={register}
            defaultValue={remixPars && remixPars.rde && remixPars.rde.split('||)')[0]}
          />
        </FormGroup>
      </Row>
      <Row className="mb-4">
        <Col md={4}>
          <p>
            {Strings('video_clip_sound_allowed')}
            <span className='ml-1'><i id='rmcsa-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rmcsa-info'
          >
            {Strings('rmcsa_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, rmcsa: remixPars.rmcsa === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.rmcsa !== 'undefined' && parseInt(remixPars.rmcsa) === 1,
                'switch-off': remixPars && remixPars.rmcsa !== 'undefined' && parseInt(remixPars.rmcsa) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <p>
            {Strings('auto_approve_media')}
            <span className='ml-1'><i id='rautoapp-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rautoapp-info'
          >
            {Strings('rautoapp_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, rautoapp: remixPars.rautoapp === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.rautoapp !== 'undefined' && parseInt(remixPars.rautoapp) === 1,
                'switch-off': remixPars && remixPars.rautoapp !== 'undefined' && parseInt(remixPars.rautoapp) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <p>
            {Strings('show_sent_message')}
            <span className='ml-1'><i id='rssm-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rssm-info'
          >
            {Strings('rssm_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, rssm: remixPars.rssm === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.rssm !== 'undefined' && parseInt(remixPars.rssm) === 1,
                'switch-off': remixPars && remixPars.rssm !== 'undefined' && parseInt(remixPars.rssm) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={4}>
          <p>
            {Strings('show_media_message')}
            <span className='ml-1'><i id='rsmir-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rsmir-info'
          >
            {Strings('rsmir_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, rsmir: remixPars.rsmir === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.rsmir !== 'undefined' && parseInt(remixPars.rsmir) === 1,
                'switch-off': remixPars && remixPars.rsmir !== 'undefined' && parseInt(remixPars.rsmir) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <p>
            {Strings('stop_to_receive_media')}
            <span className='ml-1'><i id='blksnow-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='blksnow-info'
          >
            {Strings('blksnow_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, blksnow: remixPars.blksnow === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.blksnow !== 'undefined' && parseInt(remixPars.blksnow) === 1,
                'switch-off': remixPars && remixPars.blksnow !== 'undefined' && parseInt(remixPars.blksnow) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6}>
          <p>
            {Strings('featured_score_for_OWNER_new_media')}
            {remixPars && remixPars.rfsownernm && <small>{`(${remixPars.rfsownernm})`}</small>}
            <span className='ml-2'><i id='rfsownernm-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rfsownernm-info'
          >
            {Strings('rfsownernm_tooltip')}
          </UncontrolledTooltip>

          <Slider
            className="mb-2"
            min={1}
            max={99}
            value={remixPars && remixPars.rfsownernm !== 'undefined' && parseInt(remixPars.rfsownernm)}
            defaultValue={remixPars && remixPars.rfsownernm !== 'undefined' && parseInt(remixPars.rfsownernm)}
            onChange={(value) => setRemixPars({ ...remixPars, rfsownernm: value })}
          />
        </Col>
        <Col md={6}>
          <p>
            {Strings('featured_score_for_new_media')}
            {remixPars && remixPars.rfsnm && <small>{`(${remixPars.rfsnm})`}</small>}
            <span className='ml-2'><i id='rfsnm-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rfsnm-info'
          >
            {Strings('rfsnm_tooltip')}
          </UncontrolledTooltip>

          <Slider
            className="mb-2"
            min={1}
            max={99}
            value={remixPars && remixPars.rfsnm !== 'undefined' && parseInt(remixPars.rfsnm)}
            defaultValue={remixPars && remixPars.rfsnm !== 'undefined' && parseInt(remixPars.rfsnm)}
            onChange={(value) => setRemixPars({ ...remixPars, rfsnm: value })}
          />
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={12}>
          <p
            className='pointer'
            onClick={() => setShowLocation(!showLocation)}
          >
            {Strings('location')}
            <span className='ml-2'><i id='location-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='location-info'
          >
            {Strings('set_the_location_for_the_video')}
          </UncontrolledTooltip>
          <Autocomplete
            className={`form-control ${(!showLocation) ? "d-none" : ""}`}
            apiKey={GOOGLE_MAPS_API_KEY}
            onPlaceSelected={(place) => {
              if (toggleCustomLatiLong && place && place.formatted_address) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                toggleCustomLatiLong(lat, lng);
              }
            }}
            options={{ types: [] }}
          />
        </Col>
      </Row>

      <Row className='mt-2'>
        <Col md={12}>
          <Button
            className='btn-wide'
            color='primary'
            onClick={handleSubmit(modifyRemix)}
          >
            {Strings('save')}
          </Button>
        </Col>
      </Row>

      <Row className='mt-5'>
        <Col>
          <p>
            {Strings('other_options')}
          </p>
          <Button
            color="danger"
            className="mt-1"
            onClick={toggleModalRemoveVideo}
          >
            {Strings('remove_video_from_campaign')}
          </Button>
        </Col>
      </Row>

      <Modal
        isOpen={modalRemoveVideo}
        toggle={toggleModalRemoveVideo}
      >
        <ModalHeader toggle={toggleModalRemoveVideo}>
          {Strings('confirm_remove_video')}
        </ModalHeader>
        <ModalBody>
          <p>
            {Strings('are_you_sure_remove_video')}
          </p>

          {currentIt && (
            <ListGroup>
              <ListGroupItem>
                <div className='widget-content p-0'>
                  <div className='widget-content-wrapper'>
                    <div className='widget-content-left mr-3'>
                      <a
                        href={`${PUBLIC_VIDEOS_URL}+${currentIt.tid}`}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          width={92}
                          className='rounded'
                          src={COVER_IMG_LOCATION.replace('{id}', currentIt.rid)}
                          alt={currentIt.rti}
                        />
                      </a>
                    </div>
                    <div className='widget-content-left'>
                      <div className='widget-heading'>
                        {currentIt.rti}
                      </div>
                      <div className='widget-subheading'>
                        {`*${currentIt.rstag}`}
                      </div>
                    </div>
                  </div>
                </div>
              </ListGroupItem>
            </ListGroup>
          )}

          <div className="text-left mt-4">
            <Button
              className="btn-wide mb-2 mr-2"
              size="md"
              color="danger"
              onClick={confirmRemoveVideoFromCampaign}
            >
              {Strings('yes_remove_video')}
            </Button>
            <Button
              className="btn-wide mb-2 mr-2"
              size="md"
              color="primary"
              onClick={toggleModalRemoveVideo}
            >
              {Strings('cancel')}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}
